import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import MainLayout from './pages/layouts/MainLayout';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import UsersAdminPage from './pages/UsersAdmin/UsersAdminPage';
import UserSessionsAdminPage from './pages/UserSessionsAdmin/UsersSessionsAdminPage';
import UserRolesAdminPage from './pages/UserRolesAdmin/UserRolesAdminPage';
import ActiveAdSpacesAdminPage from './pages/ActiveAdSpacesAdmin/ActiveAdSpacesAdminPage';
import AdSpacesAdminPage from './pages/AdSpacesAdmin/AdSpacesAdminPage';
import AdSpaceMediaTypesAdminPage from './pages/AdSpaceMediaTypesAdmin/AdSpaceMediaTypesAdminPage';
import AdSpaceOwnerPackagesAdminPage from './pages/AdSpaceOwnerPackagesAdmin/AdSpaceOwnerPackagesAdminPage';
import AdSpacePhotosAdminPage from './pages/AdSpacePhotosAdmin/AdSpacePhotosAdminPage';
import AdSpacePhotoCommentsAdminPage from './pages/AdSpacePhotoCommentsAdmin/AdSpacePhotoCommentsAdminPage';
import TokenPlansAdminPage from './pages/AdSpaceTokenPlansAdmin/AdSpaceTokenPlansAdminPage';
import ApiTokensAdminPage from './pages/AdSpaceApiTokensAdmin/AdSpaceApiTokensAdminPage';
import PurchasePlansAdminPage from './pages/AdSpacePurchasePlansAdmin/AdSpacePurchasePlansAdminPage';
import SizeDataTypesAdminPage from './pages/AdSpaceSizeDataTypesAdmin/AdSpaceSizeDataTypesAdminPage';
import SubscriptionPlansAdminPage from './pages/AdSpaceSubscriptionPlansAdmin/AdSpaceSubscriptionPlansAdminPage';
import SystemNotificationsAdminPage from './pages/SystemNotificationsAdmin/SystemNotificationsAdminPage';
import UsersPurchasePlansAdminPage from './pages/AdSpaceUsersPurchasePlansAdmin/AdSpaceUsersPurchasePlansAdminPage';
import UsersSubscriptionPlansAdminPage from './pages/AdSpaceUsersSubscriptonPlansAdmin/AdSpaceUsersSubscriptonPlansAdminPage';
import UsersTokenPlanTokensAdminPage from './pages/AdSpaceUsersTokenPlanTokensAdmin/AdSpaceUsersTokenPlanTokensAdminPage';
import CurrenciesAdminPage from './pages/CurrenciesAdmin/CurrenciesAdminPage';
import AdSpaceCouponCodesAdminPage from './pages/AdSpaceCouponCodesAdmin/AdSpaceCouponCodesAdminPage';
import CouponCodesAdminPage from './pages/CouponCodesAdmin/CouponCodesAdminPage';
import EmailEventsAdminPage from './pages/EmailEventsAdmin/EmailEventsAdminPage';
import AdminPaymentDetailsPage from './pages/adminPaymentDetails/AdminPaymentDetailsPage';
import AdminRefundRequestPage from './pages/adminRefundRequests/AdminRefundRequestPage';
import PayoutsManagementPage from './pages/PayoutsManagement/PayoutsManagementPage';
import AdminSupportDashboard from './pages/AdminSupportDashboard/AdminSupportDashboard';

import authStore from './store/authStore';

const AppRoutes = observer(() => (
  <Router>
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          path="/"
          element={
            authStore.isAuthenticated
              ? <Navigate to="/home" />
              : <LoginPage />
          }
        />
        <Route
          path="/home"
          element={
            authStore.isAuthenticated
              ? <Home />
              : <Navigate to="/" />
          }
        />

          <Route
          path="/supportDashboard"
          element={
            authStore.isAuthenticated
              ? <AdminSupportDashboard />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/adSpaces"
          element={
            authStore.isAuthenticated
              ? <AdSpacesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/activeAdSpaces"
          element={
            authStore.isAuthenticated
              ? <ActiveAdSpacesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/adSpaceOwnerPackages"
          element={
            authStore.isAuthenticated
              ? <AdSpaceOwnerPackagesAdminPage />
              : <Navigate to="/" />
          }
        />        

        <Route
          path="/apiTokens"
          element={
            authStore.isAuthenticated
              ? <ApiTokensAdminPage />
              : <Navigate to="/" />
          }
        />        

        <Route
          path="/mediaTypes"
          element={
            authStore.isAuthenticated
              ? <AdSpaceMediaTypesAdminPage />
              : <Navigate to="/" />
          }
        />        

        <Route
          path="/purchasePlans"
          element={
            authStore.isAuthenticated
              ? <PurchasePlansAdminPage />
              : <Navigate to="/" />
          }
        />            

        <Route
          path="/sizeDataTypes"
          element={
            authStore.isAuthenticated
              ? <SizeDataTypesAdminPage />
              : <Navigate to="/" />
          }
        /> 

        <Route
          path="/subscriptionPlans"
          element={
            authStore.isAuthenticated
              ? <SubscriptionPlansAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/systemNotifications"
          element={
            authStore.isAuthenticated
              ? <SystemNotificationsAdminPage />
              : <Navigate to="/" />
          }
        />                  

        <Route
          path="/tokenPlans"
          element={
            authStore.isAuthenticated
              ? <TokenPlansAdminPage />
              : <Navigate to="/" />
          }
        />         

        <Route
          path="/adSpacePhotos"
          element={
            authStore.isAuthenticated
              ? <AdSpacePhotosAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/adSpacePhotoComments"
          element={
            authStore.isAuthenticated
              ? <AdSpacePhotoCommentsAdminPage />
              : <Navigate to="/" />
          }
        />     
          
        <Route
          path="/users"
          element={
            authStore.isAuthenticated
              ? <UsersAdminPage />
              : <Navigate to="/" />
          }
        />
        <Route
          path="/userSessions"
          element={
            authStore.isAuthenticated
              ? <UserSessionsAdminPage />
              : <Navigate to="/" />
          }
        />
        <Route
          path="/userRoles"
          element={
            authStore.isAuthenticated
              ? <UserRolesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/usersPurchasePlans"
          element={
            authStore.isAuthenticated
              ? <UsersPurchasePlansAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/usersSubscriptionPlans"
          element={
            authStore.isAuthenticated
              ? <UsersSubscriptionPlansAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/usersTokenPlansTokens"
          element={
            authStore.isAuthenticated
              ? <UsersTokenPlanTokensAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route                     
          path="/currencies"
          element={
            authStore.isAuthenticated
              ? <CurrenciesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/adSpaceCouponCodes"
          element={
            authStore.isAuthenticated
              ? <AdSpaceCouponCodesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/couponCodes"
          element={
            authStore.isAuthenticated
              ? <CouponCodesAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/emailEvents"
          element={
            authStore.isAuthenticated
              ? <EmailEventsAdminPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/paymentDetails"
          element={
            authStore.isAuthenticated
              ? <AdminPaymentDetailsPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/refundRequests"
          element={
            authStore.isAuthenticated
              ? <AdminRefundRequestPage />
              : <Navigate to="/" />
          }
        />

        <Route
          path="/payouts"
          element={
            authStore.isAuthenticated
              ? <PayoutsManagementPage />
              : <Navigate to="/" />
          }
        />

        {/* Add more protected routes here */}
      </Route>
    </Routes>
  </Router>
));

export default AppRoutes;